module.exports = {"id":"216811","name":"Kendall Waston","rating":"74","photo":"./data/images/photos/0/216811.png","club":{"name":"Whitecaps FC","logo":"./data/images/clubs/WhitecapsFC.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KendallWaston0.json
// module id = 2322
// module chunks = 0